







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SectionWithList extends Vue {
  @Prop() private list!: ['Missing list'];
  @Prop() private title!: string;
}
